import { createRouter, createWebHistory } from 'vue-router'

import LoginView from '@base/pages/Login'

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: HomeView
  // },
  {
    path: '/login',
    name: 'login',
    sectionTitle:'Login',
    loggedOut: true,
    component: LoginView
  },

  // REVIEWS
  //{ path: '/checklist/:id/:hash', title:'Checklist',name: 'checklist', component: () => import('@portal/custom/Checklist/Checklist') },
  { path: '/checklist/:programid/:reviewid/:hash', title:'Checklist',name: 'checklist', component: () => import('@portal/custom/Checklist/Checklist') },
  { path: '/assessor/:programid/:reviewid/:hash', title:'Assessor',name: 'assessor', component: () => import('@portal/custom/Assessor/AssessorApp') },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  document.title = process.env.VUE_APP_COMPANY_NAME;
  next();
});

export default router
